const clientId = "hotsauce";
const clientSecret = "ACA44ED9-0739-4C41-B733-AE47E3A8EA6E";
const baseUrl = "https://sandbox.stonegridusa.com/StoneApp.HotSauceAPI";

export async function getAccessToken(username, password) {
  const clientCredentials = btoa(`${clientId}:${clientSecret}`);

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Basic ${clientCredentials}`,
  };

  // Body contains only grant_type, username, password
  const body = new URLSearchParams();
  body.append("grant_type", "password");
  body.append("username", username);
  body.append("password", password);

  const response = await fetch(`${baseUrl}/Token`, {
    method: "POST",
    headers,
    body,
  });

  if (!response.ok) {
    const msg = await response.text();
    throw new Error("Token request failed: " + msg);
  }

  return await response.json();
}

export async function getJobDetails(token, jobNo) {
  const response = await fetch(`${baseUrl}/job/${jobNo}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error("Failed to fetch job details");
  return await response.json();
}

export async function addJobItem(token, jobNo, payload) {
  const response = await fetch(`${baseUrl}/job/${jobNo}/AddItem`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const msg = await response.text();
    throw new Error("Failed to add job item: " + msg);
  }

  return await response.json();
}

export async function addJobItems(token, jobNo, payloads) {
  const response = await fetch(`${baseUrl}/job/${jobNo}/AddItems`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payloads),
  });

  if (!response.ok) {
    const msg = await response.text();
    throw new Error("Failed to add job items: " + msg);
  }

  return await response.json();
}

// Wrapper functions to match your existing interface
const getJob = async (creds, jobId) => {
  console.log({ creds, jobId });
  try {
    const tokenData = await getAccessToken(creds.username, creds.password);
    const token = tokenData.access_token;
    return await getJobDetails(token, jobId);
  } catch (error) {
    console.error("Get job error:", error);
    throw error;
  }
};

const postData = async (creds, data) => {
  try {
    const tokenData = await getAccessToken(creds.username, creds.password);
    const token = tokenData.access_token;

    const client = data.details.client;
    const accepted = data.details.cart.accepted;
    const jobNo = client.job;

    // Build all items for batch submission
    const items = accepted.map((item) => ({
      JobID: parseInt(jobNo),
      AccountID: 0,
      CustomerID: parseInt(client.id),
      OfferingName: item.sales_option,
      OfferingQty: parseInt(data.details.cart.quantity[item.id]),
      OfferingPrice: parseFloat((item.price / 100).toFixed(2)),
      OfferingUnit: parseInt(item.unit_type),
      TypeID: 22, // Updated field name from ItemType to TypeID
    }));

    // Use the batch endpoint for multiple items (more efficient)
    if (items.length > 1) {
      const res = await addJobItems(token, jobNo, items);
      console.log({ res });
      return res;
    } else if (items.length === 1) {
      const res = await addJobItem(token, jobNo, items[0]);
      console.log({ res });
      return res;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Post data error:", error);
    throw error;
  }
};

export default {
  getJob,
  postData,
  getAccessToken,
  getJobDetails,
};
